var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5478 28.1408C29.3788 28.8363 28.8363 29.3788 28.1408 29.5478C20.1717 31.4841 11.8283 31.4841 3.85921 29.5478C3.16372 29.3788 2.62121 28.8363 2.45222 28.1408C0.515928 20.1717 0.515927 11.8283 2.45222 3.85921C2.62121 3.16372 3.16372 2.6212 3.85921 2.45222C11.8283 0.515927 20.1717 0.515928 28.1408 2.45222C28.8363 2.62121 29.3788 3.16372 29.5478 3.85921C31.4841 11.8283 31.4841 20.1717 29.5478 28.1408Z",
    fill: "#80AF26"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.5478 28.1408C29.3788 28.8363 28.8363 29.3788 28.1408 29.5478C20.1717 31.4841 11.8283 31.4841 3.85921 29.5478C3.16372 29.3788 2.62121 28.8363 2.45222 28.1408C0.515928 20.1717 0.515927 11.8283 2.45222 3.85921C2.62121 3.16372 3.16372 2.6212 3.85921 2.45222C11.8283 0.515927 20.1717 0.515928 28.1408 2.45222C28.8363 2.62121 29.3788 3.16372 29.5478 3.85921C31.4841 11.8283 31.4841 20.1717 29.5478 28.1408Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.12,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7,
    y1: 31,
    x2: 7,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.35080726656960c5bb93761332e4dd39.svg";
export { ForwardRef as ReactComponent };